import React from 'react';
import CardAction from '../Card/CardAction';

const Action = (props) => {
  return (
    <section className='bg-grey'>
      <div className='cards-section'>
        {props.actions.map((obj, index) => (
          <CardAction key={index} data={obj} />
        ))}
      </div>
    </section>
  );
};

export default Action;
